import { ref, onMounted } from "vue";
import Auth from "@/controller/auth";
import SkinProfileController, {
  SkinProfile,
  SkinProfileToAdd
} from "@/controller/skin-profile";

export default function useSkinProfiles() {
  const userPhone = Auth.getUserUid() as string;
  const controller = new SkinProfileController(userPhone);

  const skinProfiles = ref<SkinProfile[]>([]);

  onMounted(async () => {
    skinProfiles.value = await controller.fetchSkinProfilesByPhone();
  });

  const deleteSkinProfile = async (skinProfileId: string) => {
    controller.deleteSkinProfile(skinProfileId).then(() => {
      skinProfiles.value = skinProfiles.value.filter(
        (p) => p.id !== skinProfileId
      );
    });
  };

  const addSkinProfile = async (skinProfileToAdd: SkinProfileToAdd) => {
    await controller.addSkinProfile(skinProfileToAdd);
    skinProfiles.value = await controller.fetchSkinProfilesByPhone();
  };

  return {
    skinProfiles,
    deleteSkinProfile,
    addSkinProfile
  };
}
